import { render } from "./BoardSimpleRank.vue?vue&type=template&id=708c0309&scoped=true"
import script from "./BoardSimpleRank.vue?vue&type=script&lang=js"
export * from "./BoardSimpleRank.vue?vue&type=script&lang=js"

import "./BoardSimpleRank.vue?vue&type=style&index=0&id=708c0309&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708c0309"],['__file',"src/components/h5/board/BoardSimpleRank.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "708c0309"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('708c0309', __exports__)) {
    api.reload('708c0309', __exports__)
  }
  
  module.hot.accept("./BoardSimpleRank.vue?vue&type=template&id=708c0309&scoped=true", () => {
    api.rerender('708c0309', render)
  })

}


export default __exports__